<template>
    <div class="LimitTime padding-20 bgc box-shadow">
        <keep-alive include="LotteryList">
            <router-view></router-view>
        </keep-alive>
    </div>
</template>

<script>
    export default {
        name: 'LimitTime',
        data() {
            return {}
        },
        mounted() {
        },
        methods: {},
        filters: {},
        watch: {},
        computed: {},
        components: {}
    }
</script>

<style lang="scss" type="text/scss">
    .LimitTime {
        min-width: 960px;
        box-sizing: border-box;
        font-family: PingFangSC-Regular, PingFang SC;
    }
</style>
